// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs';
import { of } from 'rxjs';

// Store
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

// Actions
import * as resetPass from '../resetPass/resetPass.actions';

// Service
import { SoledadAuthenticationService } from '../../../shared/services/b2b/auth.service';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ResetPassEffects {
    constructor(private authService: SoledadAuthenticationService, private actions$: Actions) {}

    doReset$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(resetPass.resetPassActionTypes.DO_RESET),
            switchMap((action: resetPass.DoReset) =>
                this.authService.resetPassword(action.payload.token, action.payload.password).pipe(
                    map((data) => new resetPass.DoResetSuccess(data)),
                    catchError((error) => of(new resetPass.DoResetFail(error)))
                )
            )
        )
    );
}
